// ============================================================
// 请求封装层
//  - 开关 VUE_APP_MOCK=true 时走本地 mock；否则走真实后端（与小程序接口约定一致）
//  - 服务端约定：响应体 { code:200, msg, data }；401 时清登录态并跳登录页
//  - 统一返回 { code, msg, data, header }，header 供登录接口取 token
// ============================================================
import axios from 'axios'
import mock from './mock'
import { useUserStore } from '@/store/user'
import router from '@/router'
import { toast } from '@/utils/toast'

export const MOCK_ENABLED = process.env.VUE_APP_MOCK === 'true'
export const BASE_URL = process.env.VUE_APP_BASE_URL || ''

export const TOKEN_KEY = 'echo_token'
export const USER_KEY = 'echo_user'

/** 统一请求入口（api 层只面向本函数） */
export async function request(options) {
  let payload = options.data

  // mock 模式：FormData 转普通对象（mock 无需真实文件）
  if (MOCK_ENABLED && payload instanceof FormData) {
    const obj = {}
    payload.forEach((val, key) => {
      obj[key] = val
    })
    payload = obj
  }

  if (MOCK_ENABLED) {
    const r = await mock.request({ ...options, data: payload })
    if (r.code === 200) return { code: r.code, msg: r.msg, data: r.data, header: {} }
    const err = new Error(r.msg || '请求失败')
    err.code = r.code
    throw err
  }
  return realRequest({ ...options, data: payload })
}

/** 真实后端请求（axios） */
function realRequest(options) {
  const store = useUserStore()
  return new Promise((resolve, reject) => {
    let data = options.data || {}
    const headers = {
      Authorization: store.token,
      ...(options.header || {})
    }
    // form-urlencoded 表单提交（预设音色生成等，与小程序 header 一致）
    if (options.formUrlEncoded) {
      headers['Content-Type'] = 'application/x-www-form-urlencoded'
      data = new URLSearchParams(data)
    }
    axios({
      url: BASE_URL + options.url,
      method: options.method || 'GET',
      data,
      headers,
      timeout: 20000
    })
      .then((res) => {
        const body = res.data
        if (body && body.code === 200) {
          resolve({ code: body.code, msg: body.msg, data: body.data, header: res.headers })
        } else {
          reject(new Error((body && body.msg) || '请求失败'))
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          store.logout()
          toast.error('登录已失效，请重新登录')
          router.push('/login')
          reject(new Error('登录已失效，请重新登录'))
          return
        }
        reject(new Error((err.response && err.response.data && err.response.data.msg) || '网络请求失败，请检查网络'))
      })
  })
}

/** 读取/写入登录态（localStorage） */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}
export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  } catch (e) {
    return null
  }
}
export function saveLogin(token, user) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_KEY, JSON.stringify(user || null))
}
export function clearLogin() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}
